// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--as-car-con-st{
    width: 472px;
    height: calc(100vh - 144px);
    background-color: rgba(10, 10, 10, 1);
    overflow-Y: auto;
}

.scl--accs-na-bo{
    width: 100%;
    height: 100%;
}

.scl--anb-bo-ite-con{
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 15px;
    padding-left: 139px;
    background: rgba(28, 27, 27, 1);
    border: 1px solid rgba(255, 255, 255, 0.03);
    cursor: pointer;
}

.scl--anb-conduc-item{
    width: 100%;
    height: auto;
}

.scl--abic-ea-na, .scl--abic-ic-ea-na{
    font-family: var(--primary-font);
    font-size: 18px;
    color: rgba(125, 129, 135, 1);
    transition: all 0.5s;
    padding-bottom: 2px;
}

.scl--abic-ic-ea-na.active{
    transform: rotate(350deg);
}

.scl--mop-pos-fi-mod-al {
  width: 100%;
  padding-right: 15px;
  padding-left: 139px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transform: translateY(-4px);
  padding-top: 0;
  padding-bottom: 0;
  transition:
    max-height 0.55s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.35s ease-out,
    transform 0.35s ease-out,
    padding 0.4s ease;
}

.scl--mop-pos-fi-mod-al.active {
  max-height: 2000px; 
  opacity: 1;
  transform: translateY(0);

  padding-top: 24px;
  padding-bottom: 24px;
}

.scl--mpfma-bo-con-st{
    width: 100%;
    height: 23px;
    display: flex;
    align-items: center;
    gap: 40px;
}

.scl--mbcs-sp-con-st{
    width: 100%;
    font-size: 18px;
    font-family: var(--primary-font);
    color: rgba(125, 129, 135, 1);
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.scl--mbcs-sp-con-st:hover{
    color: rgba(216, 216, 216, 1);
}

.scl--mbcs-sp-con-st.active{
    color: rgba(216, 216, 216, 1);
}


.scl--mbcs-in-st-con input[type="checkbox"],
.scl--mbcs-in-st-con input[type="radio"] {
    width: 22px;
    height: 22px;
    appearance: none;
    -webkit-appearance: none;
    background-color: transparent;
    border: 1px solid rgba(125, 129, 135, 1);
    cursor: pointer;
    position: relative;
    display: inline-grid;
    place-items: center;
    transition: all 0.3s;
}

.scl--mbcs-in-st-con input[type="checkbox"]::after {
    content: "";
    width: 5px;
    height: 11px;
    border-right: 2px solid rgba(255, 255, 255, 1);  
    border-bottom: 2px solid rgba(255, 255, 255, 1); /* red */
    transform: rotate(45deg) scale(0);
    transition: all 0.15s ;
}

.scl--mbcs-in-st-con input[type="checkbox"]:checked::after {
    transform: rotate(45deg) scale(1) translateY(-1px) translateX(-1px);
}

.scl--mbcs-in-st-con input[type="checkbox"]:checked{
    background-color: rgba(105, 131, 94, 1);
    border: 1px solid rgba(164, 186, 156, 1);
}

.scl--mbcs-in-st-con input:hover{
    border: 1px solid rgba(255, 255, 255, 1);
}

@media (max-width: 850px) {
    .scl--as-car-con-st{
        width: 240px;
    }

    .scl--anb-bo-ite-con{
        padding-left: var(--global-tablet-padding-left);
    }

    .scl--mop-pos-fi-mod-al{
        padding-left: 40px;
    }

    .scl--mpfma-bo-con-st{
        gap: 15px;
    }
}

@media (max-width: 500px) {
    .scl--anb-bo-ite-con{
        padding-left: var(--global-mobile-padding-left);
    }

    .scl--as-car-con-st{
        width: 100vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-position/css/jp_Sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,2BAA2B;IAC3B,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,+BAA+B;IAC/B,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB;;;;qBAImB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;;EAExB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;;IAEI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,6BAA6B;IAC7B,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,8CAA8C;IAC9C,+CAA+C,EAAE,QAAQ;IACzD,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,mEAAmE;AACvE;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,+CAA+C;IACnD;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".scl--as-car-con-st{\n    width: 472px;\n    height: calc(100vh - 144px);\n    background-color: rgba(10, 10, 10, 1);\n    overflow-Y: auto;\n}\n\n.scl--accs-na-bo{\n    width: 100%;\n    height: 100%;\n}\n\n.scl--anb-bo-ite-con{\n    width: 100%;\n    height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-right: 15px;\n    padding-left: 139px;\n    background: rgba(28, 27, 27, 1);\n    border: 1px solid rgba(255, 255, 255, 0.03);\n    cursor: pointer;\n}\n\n.scl--anb-conduc-item{\n    width: 100%;\n    height: auto;\n}\n\n.scl--abic-ea-na, .scl--abic-ic-ea-na{\n    font-family: var(--primary-font);\n    font-size: 18px;\n    color: rgba(125, 129, 135, 1);\n    transition: all 0.5s;\n    padding-bottom: 2px;\n}\n\n.scl--abic-ic-ea-na.active{\n    transform: rotate(350deg);\n}\n\n.scl--mop-pos-fi-mod-al {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 139px;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transform: translateY(-4px);\n  padding-top: 0;\n  padding-bottom: 0;\n  transition:\n    max-height 0.55s cubic-bezier(0.4, 0, 0.2, 1),\n    opacity 0.35s ease-out,\n    transform 0.35s ease-out,\n    padding 0.4s ease;\n}\n\n.scl--mop-pos-fi-mod-al.active {\n  max-height: 2000px; \n  opacity: 1;\n  transform: translateY(0);\n\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n\n.scl--mpfma-bo-con-st{\n    width: 100%;\n    height: 23px;\n    display: flex;\n    align-items: center;\n    gap: 40px;\n}\n\n.scl--mbcs-sp-con-st{\n    width: 100%;\n    font-size: 18px;\n    font-family: var(--primary-font);\n    color: rgba(125, 129, 135, 1);\n    cursor: pointer;\n    transition: all 0.3s;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.scl--mbcs-sp-con-st:hover{\n    color: rgba(216, 216, 216, 1);\n}\n\n.scl--mbcs-sp-con-st.active{\n    color: rgba(216, 216, 216, 1);\n}\n\n\n.scl--mbcs-in-st-con input[type=\"checkbox\"],\n.scl--mbcs-in-st-con input[type=\"radio\"] {\n    width: 22px;\n    height: 22px;\n    appearance: none;\n    -webkit-appearance: none;\n    background-color: transparent;\n    border: 1px solid rgba(125, 129, 135, 1);\n    cursor: pointer;\n    position: relative;\n    display: inline-grid;\n    place-items: center;\n    transition: all 0.3s;\n}\n\n.scl--mbcs-in-st-con input[type=\"checkbox\"]::after {\n    content: \"\";\n    width: 5px;\n    height: 11px;\n    border-right: 2px solid rgba(255, 255, 255, 1);  \n    border-bottom: 2px solid rgba(255, 255, 255, 1); /* red */\n    transform: rotate(45deg) scale(0);\n    transition: all 0.15s ;\n}\n\n.scl--mbcs-in-st-con input[type=\"checkbox\"]:checked::after {\n    transform: rotate(45deg) scale(1) translateY(-1px) translateX(-1px);\n}\n\n.scl--mbcs-in-st-con input[type=\"checkbox\"]:checked{\n    background-color: rgba(105, 131, 94, 1);\n    border: 1px solid rgba(164, 186, 156, 1);\n}\n\n.scl--mbcs-in-st-con input:hover{\n    border: 1px solid rgba(255, 255, 255, 1);\n}\n\n@media (max-width: 850px) {\n    .scl--as-car-con-st{\n        width: 240px;\n    }\n\n    .scl--anb-bo-ite-con{\n        padding-left: var(--global-tablet-padding-left);\n    }\n\n    .scl--mop-pos-fi-mod-al{\n        padding-left: 40px;\n    }\n\n    .scl--mpfma-bo-con-st{\n        gap: 15px;\n    }\n}\n\n@media (max-width: 500px) {\n    .scl--anb-bo-ite-con{\n        padding-left: var(--global-mobile-padding-left);\n    }\n\n    .scl--as-car-con-st{\n        width: 100vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
